
export interface NavMenueItem {
  label: string
  path?: string
  icon?: string
  disabled?: boolean
  externalUrl?:string
  functionKey?:string
  children?: NavMenueItem[]
}

export interface NotificationItem {
  title: string
  count: number
  link?: string
}

export interface NotificationFile {
  description: string
  descriptionLink: string
  releaseDatetime: string
  endDatetime: string
}
